// src/utils/phoneCountryCodes.js

/**
 * A list of countries with their flags and international calling codes.
 * This list is used to create a searchable dropdown for phone number inputs,
 * ensuring the correct country code is pre-selected and formatted.
 */
const phoneCountryCodes = [
    { name: "Afghanistan", flag: "🇦🇫", code: "+93" },
    { name: "Albania", flag: "🇦🇱", code: "+355" },
    { name: "Algeria", flag: "🇩🇿", code: "+213" },
    { name: "American Samoa", flag: "🇦🇸", code: "+1" },
    { name: "Andorra", flag: "🇦🇩", code: "+376" },
    { name: "Angola", flag: "🇦🇴", code: "+244" },
    { name: "Anguilla", flag: "🇦🇮", code: "+1" },
    { name: "Antarctica", flag: "🇦🇶", code: "+672" },
    { name: "Antigua and Barbuda", flag: "🇦🇬", code: "+1" },
    { name: "Argentina", flag: "🇦🇷", code: "+54" },
    { name: "Armenia", flag: "🇦🇲", code: "+374" },
    { name: "Aruba", flag: "🇦🇼", code: "+297" },
    { name: "Australia", flag: "🇦🇺", code: "+61" },
    { name: "Austria", flag: "🇦🇹", code: "+43" },
    { name: "Azerbaijan", flag: "🇦🇿", code: "+994" },
    { name: "Bahamas", flag: "🇧🇸", code: "+1" },
    { name: "Bahrain", flag: "🇧🇭", code: "+973" },
    { name: "Bangladesh", flag: "🇧🇩", code: "+880" },
    { name: "Barbados", flag: "🇧🇧", code: "+1" },
    { name: "Belarus", flag: "🇧🇾", code: "+375" },
    { name: "Belgium", flag: "🇧🇪", code: "+32" },
    { name: "Belize", flag: "🇧🇿", code: "+501" },
    { name: "Benin", flag: "🇧🇯", code: "+229" },
    { name: "Bermuda", flag: "🇧🇲", code: "+1" },
    { name: "Bhutan", flag: "🇧🇹", code: "+975" },
    { name: "Bolivia, Plurinational State of", flag: "🇧🇴", code: "+591" },
    { name: "Bonaire, Sint Eustatius and Saba", flag: "🇧🇶", code: "+599" },
    { name: "Bosnia and Herzegovina", flag: "🇧🇦", code: "+387" },
    { name: "Botswana", flag: "🇧🇼", code: "+267" },
    { name: "Bouvet Island", flag: "🇧🇻", code: "+47" },
    { name: "Brazil", flag: "🇧🇷", code: "+55" },
    { name: "British Indian Ocean Territory", flag: "🇮🇴", code: "+246" },
    { name: "Brunei Darussalam", flag: "🇧🇳", code: "+673" },
    { name: "Bulgaria", flag: "🇧🇬", code: "+359" },
    { name: "Burkina Faso", flag: "🇧🇫", code: "+226" },
    { name: "Burundi", flag: "🇧🇮", code: "+257" },
    { name: "Cabo Verde", flag: "🇨🇻", code: "+238" },
    { name: "Cambodia", flag: "🇰🇭", code: "+855" },
    { name: "Cameroon", flag: "🇨🇲", code: "+237" },
    { name: "Canada", flag: "🇨🇦", code: "+1" },
    { name: "Cayman Islands", flag: "🇰🇾", code: "+1" },
    { name: "Central African Republic", flag: "🇨🇫", code: "+236" },
    { name: "Chad", flag: "🇹🇩", code: "+235" },
    { name: "Chile", flag: "🇨🇱", code: "+56" },
    { name: "China", flag: "🇨🇳", code: "+86" },
    { name: "Christmas Island", flag: "🇨🇽", code: "+61" },
    { name: "Cocos (Keeling) Islands", flag: "🇨🇨", code: "+61" },
    { name: "Colombia", flag: "🇨🇴", code: "+57" },
    { name: "Comoros", flag: "🇰🇲", code: "+269" },
    { name: "Congo", flag: "🇨🇬", code: "+242" },
    { name: "Congo, The Democratic Republic of the", flag: "🇨🇩", code: "+243" },
    { name: "Cook Islands", flag: "🇨🇰", code: "+682" },
    { name: "Costa Rica", flag: "🇨🇷", code: "+506" },
    { name: "Croatia", flag: "🇭🇷", code: "+385" },
    { name: "Cuba", flag: "🇨🇺", code: "+53" },
    { name: "Curaçao", flag: "🇨🇼", code: "+599" },
    { name: "Cyprus", flag: "🇨🇾", code: "+357" },
    { name: "Czechia", flag: "🇨🇿", code: "+420" },
    { name: "Côte d'Ivoire", flag: "🇨🇮", code: "+225" },
    { name: "Denmark", flag: "🇩🇰", code: "+45" },
    { name: "Djibouti", flag: "🇩🇯", code: "+253" },
    { name: "Dominica", flag: "🇩🇲", code: "+1" },
    { name: "Dominican Republic", flag: "🇩🇴", code: "+1" },
    { name: "Ecuador", flag: "🇪🇨", code: "+593" },
    { name: "Egypt", flag: "🇪🇬", code: "+20" },
    { name: "El Salvador", flag: "🇸🇻", code: "+503" },
    { name: "Equatorial Guinea", flag: "🇬🇶", code: "+240" },
    { name: "Eritrea", flag: "🇪🇷", code: "+291" },
    { name: "Estonia", flag: "🇪🇪", code: "+372" },
    { name: "Eswatini", flag: "🇸🇿", code: "+268" },
    { name: "Ethiopia", flag: "🇪🇹", code: "+251" },
    { name: "Falkland Islands (Malvinas)", flag: "🇫🇰", code: "+500" },
    { name: "Faroe Islands", flag: "🇫🇴", code: "+298" },
    { name: "Fiji", flag: "🇫🇯", code: "+679" },
    { name: "Finland", flag: "🇫🇮", code: "+358" },
    { name: "France", flag: "🇫🇷", code: "+33" },
    { name: "French Guiana", flag: "🇬🇫", code: "+594" },
    { name: "French Polynesia", flag: "🇵🇫", code: "+689" },
    { name: "French Southern Territories", flag: "🇹🇫", code: "+262" },
    { name: "Gabon", flag: "🇬🇦", code: "+241" },
    { name: "Gambia", flag: "🇬🇲", code: "+220" },
    { name: "Georgia", flag: "🇬🇪", code: "+995" },
    { name: "Germany", flag: "🇩🇪", code: "+49" },
    { name: "Ghana", flag: "🇬🇭", code: "+233" },
    { name: "Gibraltar", flag: "🇬🇮", code: "+350" },
    { name: "Greece", flag: "🇬🇷", code: "+30" },
    { name: "Greenland", flag: "🇬🇱", code: "+299" },
    { name: "Grenada", flag: "🇬🇩", code: "+1" },
    { name: "Guadeloupe", flag: "🇬🇵", code: "+590" },
    { name: "Guam", flag: "🇬🇺", code: "+1" },
    { name: "Guatemala", flag: "🇬🇹", code: "+502" },
    { name: "Guernsey", flag: "🇬🇬", code: "+44" },
    { name: "Guinea", flag: "🇬🇳", code: "+224" },
    { name: "Guinea-Bissau", flag: "🇬🇼", code: "+245" },
    { name: "Guyana", flag: "🇬🇾", code: "+592" },
    { name: "Haiti", flag: "🇭🇹", code: "+509" },
    { name: "Heard Island and McDonald Islands", flag: "🇭🇲", code: "+672" },
    { name: "Holy See (Vatican City State)", flag: "🇻🇦", code: "+379" },
    { name: "Honduras", flag: "🇭🇳", code: "+504" },
    { name: "Hong Kong", flag: "🇭🇰", code: "+852" },
    { name: "Hungary", flag: "🇭🇺", code: "+36" },
    { name: "Iceland", flag: "🇮🇸", code: "+354" },
    { name: "India", flag: "🇮🇳", code: "+91" },
    { name: "Indonesia", flag: "🇮🇩", code: "+62" },
    { name: "Iran, Islamic Republic of", flag: "🇮🇷", code: "+98" },
    { name: "Iraq", flag: "🇮🇶", code: "+964" },
    { name: "Ireland", flag: "🇮🇪", code: "+353" },
    { name: "Isle of Man", flag: "🇮🇲", code: "+44" },
    { name: "Israel", flag: "🇮🇱", code: "+972" },
    { name: "Italy", flag: "🇮🇹", code: "+39" },
    { name: "Jamaica", flag: "🇯🇲", code: "+1" },
    { name: "Japan", flag: "🇯🇵", code: "+81" },
    { name: "Jersey", flag: "🇯🇪", code: "+44" },
    { name: "Jordan", flag: "🇯🇴", code: "+962" },
    { name: "Kazakhstan", flag: "🇰🇿", code: "+7" },
    { name: "Kenya", flag: "🇰🇪", code: "+254" },
    { name: "Kiribati", flag: "🇰🇮", code: "+686" },
    { name: "Korea, Democratic People's Republic of", flag: "🇰🇵", code: "+850" },
    { name: "Korea, Republic of", flag: "🇰🇷", code: "+82" },
    { name: "Kuwait", flag: "🇰🇼", code: "+965" },
    { name: "Kyrgyzstan", flag: "🇰🇬", code: "+996" },
    { name: "Lao People's Democratic Republic", flag: "🇱🇦", code: "+856" },
    { name: "Latvia", flag: "🇱🇻", code: "+371" },
    { name: "Lebanon", flag: "🇱🇧", code: "+961" },
    { name: "Lesotho", flag: "🇱🇸", code: "+266" },
    { name: "Liberia", flag: "🇱🇷", code: "+231" },
    { name: "Libya", flag: "🇱🇾", code: "+218" },
    { name: "Liechtenstein", flag: "🇱🇮", code: "+423" },
    { name: "Lithuania", flag: "🇱🇹", code: "+370" },
    { name: "Luxembourg", flag: "🇱🇺", code: "+352" },
    { name: "Macao", flag: "🇲🇴", code: "+853" },
    { name: "Madagascar", flag: "🇲🇬", code: "+261" },
    { name: "Malawi", flag: "🇲🇼", code: "+265" },
    { name: "Malaysia", flag: "🇲🇾", code: "+60" },
    { name: "Maldives", flag: "🇲🇻", code: "+960" },
    { name: "Mali", flag: "🇲🇱", code: "+223" },
    { name: "Malta", flag: "🇲🇹", code: "+356" },
    { name: "Marshall Islands", flag: "🇲🇭", code: "+692" },
    { name: "Martinique", flag: "🇲🇶", code: "+596" },
    { name: "Mauritania", flag: "🇲🇷", code: "+222" },
    { name: "Mauritius", flag: "🇲🇺", code: "+230" },
    { name: "Mayotte", flag: "🇾🇹", code: "+262" },
    { name: "Mexico", flag: "🇲🇽", code: "+52" },
    { name: "Micronesia, Federated States of", flag: "🇫🇲", code: "+691" },
    { name: "Moldova, Republic of", flag: "🇲🇩", code: "+373" },
    { name: "Monaco", flag: "🇲🇨", code: "+377" },
    { name: "Mongolia", flag: "🇲🇳", code: "+976" },
    { name: "Montenegro", flag: "🇲🇪", code: "+382" },
    { name: "Montserrat", flag: "🇲🇸", code: "+1" },
    { name: "Morocco", flag: "🇲🇦", code: "+212" },
    { name: "Mozambique", flag: "🇲🇿", code: "+258" },
    { name: "Myanmar", flag: "🇲🇲", code: "+95" },
    { name: "Namibia", flag: "🇳🇦", code: "+264" },
    { name: "Nauru", flag: "🇳🇷", code: "+674" },
    { name: "Nepal", flag: "🇳🇵", code: "+977" },
    { name: "Netherlands", flag: "🇳🇱", code: "+31" },
    { name: "New Caledonia", flag: "🇳🇨", code: "+687" },
    { name: "New Zealand", flag: "🇳🇿", code: "+64" },
    { name: "Nicaragua", flag: "🇳🇮", code: "+505" },
    { name: "Niger", flag: "🇳🇪", code: "+227" },
    { name: "Nigeria", flag: "🇳🇬", code: "+234" },
    { name: "Niue", flag: "🇳🇺", code: "+683" },
    { name: "Norfolk Island", flag: "🇳🇫", code: "+672" },
    { name: "North Macedonia", flag: "🇲🇰", code: "+389" },
    { name: "Northern Mariana Islands", flag: "🇲🇵", code: "+1" },
    { name: "Norway", flag: "🇳🇴", code: "+47" },
    { name: "Oman", flag: "🇴🇲", code: "+968" },
    { name: "Pakistan", flag: "🇵🇰", code: "+92" },
    { name: "Palau", flag: "🇵🇼", code: "+680" },
    { name: "Palestine, State of", flag: "🇵🇸", code: "+970" },
    { name: "Panama", flag: "🇵🇦", code: "+507" },
    { name: "Papua New Guinea", flag: "🇵🇬", code: "+675" },
    { name: "Paraguay", flag: "🇵🇾", code: "+595" },
    { name: "Peru", flag: "🇵🇪", code: "+51" },
    { name: "Philippines", flag: "🇵🇭", code: "+63" },
    { name: "Pitcairn", flag: "🇵🇳", code: "+64" },
    { name: "Poland", flag: "🇵🇱", code: "+48" },
    { name: "Portugal", flag: "🇵🇹", code: "+351" },
    { name: "Puerto Rico", flag: "🇵🇷", code: "+1" },
    { name: "Qatar", flag: "🇶🇦", code: "+974" },
    { name: "Romania", flag: "🇷🇴", code: "+40" },
    { name: "Russian Federation", flag: "🇷🇺", code: "+7" },
    { name: "Rwanda", flag: "🇷🇼", code: "+250" },
    { name: "Réunion", flag: "🇷🇪", code: "+262" },
    { name: "Saint Barthélemy", flag: "🇧🇱", code: "+590" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", flag: "🇸🇭", code: "+290" },
    { name: "Saint Kitts and Nevis", flag: "🇰🇳", code: "+1" },
    { name: "Saint Lucia", flag: "🇱🇨", code: "+1" },
    { name: "Saint Martin (French part)", flag: "🇲🇫", code: "+590" },
    { name: "Saint Pierre and Miquelon", flag: "🇵🇲", code: "+508" },
    { name: "Saint Vincent and the Grenadines", flag: "🇻🇨", code: "+1" },
    { name: "Samoa", flag: "🇼🇸", code: "+685" },
    { name: "San Marino", flag: "🇸🇲", code: "+378" },
    { name: "Sao Tome and Principe", flag: "🇸🇹", code: "+239" },
    { name: "Saudi Arabia", flag: "🇸🇦", code: "+966" },
    { name: "Senegal", flag: "🇸🇳", code: "+221" },
    { name: "Serbia", flag: "🇷🇸", code: "+381" },
    { name: "Seychelles", flag: "🇸🇨", code: "+248" },
    { name: "Sierra Leone", flag: "🇸🇱", code: "+232" },
    { name: "Singapore", flag: "🇸🇬", code: "+65" },
    { name: "Sint Maarten (Dutch part)", flag: "🇸🇽", code: "+1" },
    { name: "Slovakia", flag: "🇸🇰", code: "+421" },
    { name: "Slovenia", flag: "🇸🇮", code: "+386" },
    { name: "Solomon Islands", flag: "🇸🇧", code: "+677" },
    { name: "Somalia", flag: "🇸🇴", code: "+252" },
    { name: "South Africa", flag: "🇿🇦", code: "+27" },
    { name: "South Georgia and the South Sandwich Islands", flag: "🇬🇸", code: "+500" },
    { name: "South Sudan", flag: "🇸🇸", code: "+211" },
    { name: "Spain", flag: "🇪🇸", code: "+34" },
    { name: "Sri Lanka", flag: "🇱🇰", code: "+94" },
    { name: "Sudan", flag: "🇸🇩", code: "+249" },
    { name: "Suriname", flag: "🇸🇷", code: "+597" },
    { name: "Svalbard and Jan Mayen", flag: "🇸🇯", code: "+47" },
    { name: "Sweden", flag: "🇸🇪", code: "+46" },
    { name: "Switzerland", flag: "🇨🇭", code: "+41" },
    { name: "Syrian Arab Republic", flag: "🇸🇾", code: "+963" },
    { name: "Taiwan, Province of China", flag: "🇹🇼", code: "+886" },
    { name: "Tajikistan", flag: "🇹🇯", code: "+992" },
    { name: "Tanzania, United Republic of", flag: "🇹🇿", code: "+255" },
    { name: "Thailand", flag: "🇹🇭", code: "+66" },
    { name: "Timor-Leste", flag: "🇹🇱", code: "+670" },
    { name: "Togo", flag: "🇹🇬", code: "+228" },
    { name: "Tokelau", flag: "🇹🇰", code: "+690" },
    { name: "Tonga", flag: "🇹🇴", code: "+676" },
    { name: "Trinidad and Tobago", flag: "🇹🇹", code: "+1" },
    { name: "Tunisia", flag: "🇹🇳", code: "+216" },
    { name: "Turkey", flag: "🇹🇷", code: "+90" },
    { name: "Turkmenistan", flag: "🇹🇲", code: "+993" },
    { name: "Turks and Caicos Islands", flag: "🇹🇨", code: "+1" },
    { name: "Tuvalu", flag: "🇹🇻", code: "+688" },
    { name: "Uganda", flag: "🇺🇬", code: "+256" },
    { name: "Ukraine", flag: "🇺🇦", code: "+380" },
    { name: "United Arab Emirates", flag: "🇦🇪", code: "+971" },
    { name: "United Kingdom", flag: "🇬🇧", code: "+44" },
    { name: "United States", flag: "🇺🇸", code: "+1" },
    { name: "United States Minor Outlying Islands", flag: "🇺🇲", code: "+246" },
    { name: "Uruguay", flag: "🇺🇾", code: "+598" },
    { name: "Uzbekistan", flag: "🇺🇿", code: "+998" },
    { name: "Vanuatu", flag: "🇻🇺", code: "+678" },
    { name: "Venezuela, Bolivarian Republic of", flag: "🇻🇪", code: "+58" },
    { name: "Viet Nam", flag: "🇻🇳", code: "+84" },
    { name: "Virgin Islands, British", flag: "🇻🇬", code: "+1" },
    { name: "Virgin Islands, U.S.", flag: "🇻🇮", code: "+1" },
    { name: "Wallis and Futuna", flag: "🇼🇫", code: "+681" },
    { name: "Western Sahara", flag: "🇪🇭", code: "+212" },
    { name: "Yemen", flag: "🇾🇪", code: "+967" },
    { name: "Zambia", flag: "🇿🇲", code: "+260" },
    { name: "Zimbabwe", flag: "🇿🇼", code: "+263" },
    { name: "Åland Islands", flag: "🇦🇽", code: "+358" },
];

export default phoneCountryCodes;